import { ReactNode, useCallback, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

import { ReactComponent as Wonder } from '../../assets/svg/icons/Wonder.svg'
import Tooltip from '../Tooltip'

const QuestionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  width: 18px;
  height: 18px;
  border: none;
  background: none;
  outline: none;
  cursor: default;
  border-radius: 36px;
  font-size: 12px;
  color: ${({ theme }) => theme.deprecated_text2};
  cursor: help;

  :hover,
  :focus {
    opacity: 0.7;
  }
`

export default function QuestionHelper({ text }: { text: ReactNode; size?: number }) {
  const [show, setShow] = useState<boolean>(false)
  const timeoutRef = useRef<NodeJS.Timeout>()

  const open = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    setShow(true)
  }, [])

  const scheduleClose = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    timeoutRef.current = setTimeout(() => {
      setShow(false)
    }, 150)
  }, [])

  const cancelClose = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
  }, [])

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  return (
    <span style={{ marginLeft: 4, display: 'flex', alignItems: 'center' }}>
      <Tooltip text={text} show={show} onTooltipMouseEnter={cancelClose} onTooltipMouseLeave={scheduleClose}>
        <QuestionWrapper onClick={open} onMouseEnter={open} onMouseLeave={scheduleClose}>
          <Wonder />
        </QuestionWrapper>
      </Tooltip>
    </span>
  )
}
